import React, { useCallback, useContext, useState } from 'react';
import { Button, Modal } from 'antd';

import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import UserDetailsContext from '@totem/components/users/details/UserDetailsContext';
import IBDIcon from '@totem/styles/Icon';
import { USERS_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';

const SendWelcomeEmailButton = () => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const { user } = useContext(UserDetailsContext);
  const [isSending, setIsSending] = useState<boolean>(false);

  const onSendWelcomeEmail = useCallback(
    async (userId: string) => {
      if (isSending) return;
      setIsSending(true);

      fetch(`${USERS_ENDPOINT}/${userId}/welcome`, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getApiToken()}`,
        }),
      }).then((res) => CheckResponseShowError(res));
    },
    [isSending],
  );

  const handleSendWelcome = () => {
    Modal.confirm({
      title: 'Are you sure?',
      content: `Please confirm that you would like to resend a welcome email to ${user.email}`,
      okText: 'Send Welcome Email',
      okType: 'danger',
      cancelText: 'Cancel',
      open: false,
      onOk: () => onSendWelcomeEmail(user.id),
    });
  };

  if (
    !permissions.organizationalAdministrator.hasPermissions(userProfile) ||
    !user.organization.isActive
  ) {
    return null;
  }

  return (
    <Button onClick={handleSendWelcome} icon={<IBDIcon name={'Send'} />}>
      Resend Welcome Email
    </Button>
  );
};

export default SendWelcomeEmailButton;
